import Form from "./Form";
import { useDataContext } from "../contexts";
import { getTransactionFields } from "../utils";

export default function TransactionAdd({ user, callback }) {
  const { memberUsers } = useDataContext();

  return (
    <Form
      path="transactions"
      fields={getTransactionFields(memberUsers, user)}
      submitCallback={callback}
      initialValues={{
        user: user.id,
      }}
    />
  );
}
